import Api, { CleaningMission, HealthCenter, OPEN_CLEANING_MISSION_STATUSES } from '@silbo/core';

export const CLEANING_MISSION_INCLUDES = ['bed', 'bed.parent'];

/** Rien du séjour ni du patient n'est chargé : la mission ne porte que le lit et sa chambre. */
export const getOpenCleaningMissionsQuery = (healthCenter: HealthCenter) =>
  new Api.Query(CleaningMission)
    .equalTo('healthCenter', healthCenter)
    .containedIn('status', OPEN_CLEANING_MISSION_STATUSES)
    .include(CLEANING_MISSION_INCLUDES)
    .limit(1000);
